import {useState, useEffect} from 'react'

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import TextField from "@mui/material/TextField/TextField"

export default function ModalShopData({shop}) {

    function getFromLocalStorage(imageId){
        let data =  localStorage.getItem(imageId);
        return 'data:image/png;base64,' + data;
      }

    return (
        <>
        {shop && 
            <Grid container spacing={1} width={"20rem"}>
                <Grid item xs={12} >
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={1} pl={1}>
                        <MDAvatar src={getFromLocalStorage(shop['logo_id'])} name={shop['shop_name']} size="lg" />
                        <MDBox ml={2} lineHeight={1}>
                            <MDTypography display="block" variant="button" fontWeight="medium">
                            {shop['shop_name']}
                            </MDTypography>
                       
                        </MDBox>
                    </MDBox>
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={2} pl={1} pr={1}>
                        <TextField
                            id="standard-read-only-input"
                            label="Category"
                            defaultValue={shop["shop_category"]}
                            InputProps={{
                                readOnly: true,
                            }}
                            sx={{ width: '100%' }}
                            variant="standard"
                        />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={2} pl={1} pr={1}>
                        <TextField
                            id="standard-read-only-input"
                            label="Address"
                            multiline
                            defaultValue={shop["shop_address"]}
                            InputProps={{
                                readOnly: true,
                            }}
                            sx={{ width: '100%' }}
                            variant="standard"
                        />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={2} pl={1} pr={1}>
                        <TextField
                            id="standard-read-only-input"
                            label="City"
                            defaultValue={shop["shop_city"]}
                            InputProps={{
                                readOnly: true,
                            }}
                            sx={{ width: '100%' }}
                            variant="standard"
                        />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" lineHeight={1} pt={2} pl={1} pr={1}>
                        <TextField
                            id="standard-read-only-input"
                            label="Country"
                            defaultValue={shop["shop_country"]}
                            InputProps={{
                                readOnly: true,
                            }}
                            sx={{ width: '100%' }}
                            variant="standard"
                        />
                    </MDBox>
                </Grid>
            </Grid>
            }
        </>


    );
}